import React, { useEffect, useState } from "react";
import { ModalEditImovel } from "./ModalEditImovel";
import { DimensoesSection } from "./DimensoesSection";
import { DimensoesSectionRural } from "./DimensoesSectionRural";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
} from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import { isRural } from "../../../Utils/isRural";
import { Container } from "./styles";
import { IImovelFocus } from "../../../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import { Title } from "./DimensoesSection/styles";
import { TitleSection } from "../../../Pages/Cartorio_Pages/App_Pages/ImovelFocus/styles";
import theme from "../../../Styles/theme";

interface Props {
  imovel: IImovelFocus;
  rural?: boolean;
  handleSetImovel(im: IImovelFocus): void;
  editavel: boolean;
  handleModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export function ImovelSection({
  imovel,
  handleSetImovel,
  editavel,
  handleModal,
  rural = false,
}: Props) {
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    handleModal(!openModal);
  }, [openModal]);

  return (
    <>
      {editavel ? (
        <ModalEditImovel
          open={openModal}
          onClose={() => setOpenModal(false)}
          imovel={imovel}
          handleSetImovel={handleSetImovel}
        />
      ) : (
        ""
      )}

      <Container onClick={() => setOpenModal(true)} interactive={editavel}>
        <TitleSection>DIMENSÕES DO IMÓVEL</TitleSection>
        {rural ? (
          <DimensoesSectionRural
            id={imovel.ID}
            total={imovel.AREA}
            transmitida={imovel.AREA_TRANSMITIDA}
            APTIDAO_BOA={imovel.APTIDAO_BOA}
            APTIDAO_REGULAR={imovel.APTIDAO_REGULAR}
            APTIDAO_RESTRITA={imovel.APTIDAO_RESTRITA}
            PASTAGEM_PLANA={imovel.PASTAGEM_PLANA}
            RESERVA_NATURAL={imovel.RESERVA_NATURAL}
            SIVICULTURA={imovel.SIVICULTURA}
            TIPO_TERRA_7={imovel.TIPO_TERRA_7}
            TIPO_TERRA_8={imovel.TIPO_TERRA_8}
          />
        ) : (
          <DimensoesSection
            total={imovel.AREA}
            transmitida={imovel.AREA_TRANSMITIDA}
            frente={imovel.FRENTE}
            fundo={imovel.FUNDO}
            direita={imovel.LADO_DIREITO}
            esquerda={imovel.LADO_ESQUERDO}
          />
        )}
        <TitleSection>DESCRIÇÃO</TitleSection>

        <TableContainer style={{ padding: "0", margin: "0" }}>
          <Table
            style={{
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0",
              margin: "0",
              fontSize: "0.9rem",
              background: theme.colors.light,
              borderRadius: "0.25rem",
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    padding: "0rem",
                    border: "1px solid rgba(224, 224, 224, 1)",
                  }}
                  align={"center"}
                >
                  Localização
                </TableCell>
                {imovel.MATRICULA > 0 && (
                  <TableCell
                    style={{
                      padding: "0rem",
                      border: "1px solid rgba(224, 224, 224, 1)",
                    }}
                    align={"center"}
                  >
                    Matricula
                  </TableCell>
                )}
                {imovel.TRANSCRICAO && (
                  <TableCell
                    style={{
                      padding: "0rem",
                      border: "1px solid rgba(224, 224, 224, 1)",
                    }}
                    align={"center"}
                  >
                    Transcrição
                  </TableCell>
                )}
                <TableCell
                  style={{
                    padding: "0rem",
                    border: "1px solid rgba(224, 224, 224, 1)",
                  }}
                  align={"center"}
                >
                  Operação
                </TableCell>
                {!isRural() && imovel.ZONA && imovel.ZONA.length > 0 && (
                  <TableCell
                    style={{
                      padding: "0rem",
                      border: "1px solid rgba(224, 224, 224, 1)",
                    }}
                    align={"center"}
                  >
                    Zona
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell
                  style={{
                    border: "1px solid rgba(224, 224, 224, 1)",
                    padding: "0rem",
                  }}
                  align={"center"}
                >
                  {imovel.LOCALIZACAO || "?"}
                </TableCell>
                {imovel.MATRICULA > 0 && (
                  <TableCell
                    style={{
                      border: "1px solid rgba(224, 224, 224, 1)",
                      padding: "0rem",
                    }}
                    align={"center"}
                  >
                    {new Intl.NumberFormat("pt-BR").format(imovel.MATRICULA)}
                  </TableCell>
                )}
                {imovel.TRANSCRICAO && (
                  <TableCell
                    style={{
                      border: "1px solid rgba(224, 224, 224, 1)",
                      padding: "0rem",
                    }}
                    align={"center"}
                  >
                    {imovel.TRANSCRICAO}
                  </TableCell>
                )}
                <TableCell
                  style={{
                    border: "1px solid rgba(224, 224, 224, 1)",
                    padding: "0rem",
                  }}
                  align={"center"}
                >
                  {imovel.OPERACAO || "?"}
                </TableCell>
                {!isRural() && imovel.ZONA && imovel.ZONA.length > 0 && (
                  <TableCell
                    style={{
                      padding: "0rem",
                      border: "1px solid rgba(224, 224, 224, 1)",
                    }}
                    align={"center"}
                  >
                    {imovel.ZONA || ""}
                  </TableCell>
                )}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        {!isRural() && (
          <TableContainer
            style={{ padding: "0", margin: "0", marginTop: "4px" }}
          >
            <Table
              style={{
                border: "1px solid rgba(224, 224, 224, 1)",
                padding: "0",
                margin: "0",
                fontSize: "0.9rem",
                background: theme.colors.light,
                borderRadius: "0.25rem",
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      padding: "0rem",
                      border: "1px solid rgba(224, 224, 224, 1)",
                    }}
                    align={"center"}
                  >
                    Lote
                  </TableCell>
                  {imovel.SUBLOTE && (
                    <TableCell
                      style={{
                        padding: "0rem",
                        border: "1px solid rgba(224, 224, 224, 1)",
                      }}
                      align={"center"}
                    >
                      Sublote
                    </TableCell>
                  )}
                  <TableCell
                    style={{
                      padding: "0rem",
                      border: "1px solid rgba(224, 224, 224, 1)",
                    }}
                    align={"center"}
                  >
                    Quadra
                  </TableCell>
                  <TableCell
                    style={{
                      padding: "0rem",
                      border: "1px solid rgba(224, 224, 224, 1)",
                    }}
                    align={"center"}
                  >
                    Situação Quadra
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell
                    style={{
                      border: "1px solid rgba(224, 224, 224, 1)",
                      padding: "0rem",
                    }}
                    align={"center"}
                  >
                    {imovel.LOTE || "?"}
                  </TableCell>
                  {imovel.SUBLOTE && (
                    <TableCell
                      style={{
                        padding: "0rem",
                        border: "1px solid rgba(224, 224, 224, 1)",
                      }}
                      align={"center"}
                    >
                      {imovel.SUBLOTE || ""}
                    </TableCell>
                  )}
                  <TableCell
                    style={{
                      border: "1px solid rgba(224, 224, 224, 1)",
                      padding: "0rem",
                    }}
                    align={"center"}
                  >
                    {imovel.QUADRA || "?"}
                  </TableCell>
                  <TableCell
                    style={{
                      border: "1px solid rgba(224, 224, 224, 1)",
                      padding: "0rem",
                    }}
                    align={"center"}
                  >
                    {imovel.SITUACAO_QUADRA || "?"}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
        {editavel && (
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<EditIcon />}
              onClick={() => {
                // setAdquirenteFocus({} as IAdquirinte);
                // setOpenModal(true);
              }}
              style={{ marginTop: "4px", minWidth: "300px" }}
            >
              EDITAR IMOVEL
            </Button>
          </div>
        )}
      </Container>
    </>
  );
}
